import * as React from 'react'
import { ContextRoute } from '../app/context'
import { NavigationEntry, ServiceTypeNavigation } from '../service-type-navigation'

interface Props {
    currentRoute: ContextRoute
    navigationEntries: NavigationEntry[]
}

class MonitorNavigation extends React.Component<Props> {
    public render = () => {
        return (
            <ServiceTypeNavigation
                navigationEntries={this.props.navigationEntries}
                currentRoute={this.props.currentRoute}
                showAddMarkerButton={false}
            />
        )
    }
}

export default MonitorNavigation
